import { moment } from "@msuite/utils/date";
import z from "zod";

export const getYearlyStatisticsQuerySchema = z.object({
	year: z.string().default(moment().format("YYYY")),
});

export type GetYearlyStatisticsQuerySchema = z.infer<typeof getYearlyStatisticsQuerySchema>;
